"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCDN = void 0;
function getCDN(region) {
    return region === 'CN' ? 'https://genesis-cdn.faradayfuturecn.com' : 'https://genesis-cdn.ff.com';
}
exports.getCDN = getCDN;
